export default "__VITE_ASSET__kIAQU$QD__"